import {
  FETCH_MYSELF_REQUESTED,
  FETCH_MYSELF_SUCCESS,
  MYSELF_CHANGED,
  NAME_CHANGED,
  CHOOSE_NEW_MANTELPIECE_SUCCESS,
  CHOOSE_NEW_SCRAPBOOK_SUCCESS,
} from 'actiontypes/myself';

import {
  BUY_ITEMS_SUCCESS,
  SELL_ITEMS_SUCCESS,
} from 'actiontypes/exchange';

import chooseNewDisplayQualitySuccess from './chooseNewDisplayQualitySuccess';
import exchangeTransactionSuccess from './exchangeTransactionSuccess';
import fetchMyselfSuccess from './fetchMyselfSuccess';
import myselfChanged from './myselfChanged';
import nameChanged from './nameChanged';
import { IMyselfState } from 'types/myself';

// This is the expected state structure; we're explicitly setting
// things as undefined so that we have a record of how we expect it to look
export const INITIAL_STATE: IMyselfState = {
  categories: [],
  character: {
    avatarImage: 'beardy',
    currentDomicile: {
      description: undefined,
      image: undefined,
      maxHandSize: undefined,
      name: undefined,
    },
    description: undefined,
    descriptiveText: undefined,
    id: undefined,
    mantelpieceItemId: undefined,
    name: 'Someone',
    outfits: [],
    scrapbookStatusId: undefined,
  },
  hasFetched: false, // Set to true when we fetch successfully
  isFetching: false,
  isRequestingItemUse: false,
  qualities: [],
};

export default function reducer(state = INITIAL_STATE, action: { type: string, payload: any }) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_MYSELF_REQUESTED:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_MYSELF_SUCCESS:
      return fetchMyselfSuccess(state, payload);

    case MYSELF_CHANGED:
      return myselfChanged(state, payload);

    case NAME_CHANGED:
      return nameChanged(state, payload);

    case BUY_ITEMS_SUCCESS:
    case SELL_ITEMS_SUCCESS:
      return exchangeTransactionSuccess(state, payload);

    case CHOOSE_NEW_MANTELPIECE_SUCCESS:
      return chooseNewDisplayQualitySuccess(state, payload, 'mantelpieceItemId');

    case CHOOSE_NEW_SCRAPBOOK_SUCCESS:
      return chooseNewDisplayQualitySuccess(state, payload, 'scrapbookStatusId');

    default:
      return state;
  }
}